import { ButtonModule, StaggeredContentModule } from '@frk/eds-components';

import { BrSdkModule } from '@bloomreach/ng-sdk';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { StaggeredSectionComponent } from './staggered-section.component';

@NgModule({
  declarations: [StaggeredSectionComponent],
  imports: [BrSdkModule, CommonModule, StaggeredContentModule, ButtonModule],
  exports: [StaggeredSectionComponent],
  entryComponents: [StaggeredSectionComponent],
})

/**
 * Staggered Section Module
 */
export class StaggeredSectionModule {}
